"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function DataAuthorize(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 2a1.5 1.5 0 000 3h9a1.5 1.5 0 000-3h-9zm0-1h9a2.5 2.5 0 110 5h-9a2.5 2.5 0 110-5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 3a.5.5 0 110 1 .5.5 0 010-1zm3 0a.5.5 0 010 1h-1a.5.5 0 010-1h1zm-3 4a.5.5 0 110 1 .5.5 0 010-1zm3 0a.5.5 0 010 1h-1a.5.5 0 010-1h1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 6V5H2.5a2.5 2.5 0 100 5h4V9h-4a1.5 1.5 0 010-3H7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 14a2.5 2.5 0 01-.164-4.995L2.5 9h4a.5.5 0 01.09.992L6.5 10h-4a1.5 1.5 0 00-.144 2.993L2.5 13h4a.5.5 0 010 1h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 11h1a.5.5 0 010 1h-1a.5.5 0 010-1zM9 11v4h6v-4H9zm0-1h6a1 1 0 011 1v4a1 1 0 01-1 1H9a1 1 0 01-1-1v-4a1 1 0 011-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12a1 1 0 110 2 1 1 0 010-2zM13 10V8.8c0-.417-.426-.8-1-.8s-1 .383-1 .8V10h-1V8.8c0-.994.895-1.8 2-1.8s2 .806 2 1.8V10h-1z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(DataAuthorize);
var _default = ForwardRef;
exports["default"] = _default;